import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Index from "./Index";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate("/");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="relative min-h-screen overflow-hidden">
      {/* Blurred background - Main page */}
      <div className="absolute inset-0 blur-md scale-105 pointer-events-none">
        <Index />
      </div>

      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />

      {/* Modal */}
      <div className="absolute inset-0 flex items-center justify-center z-50">
        <div className="glass-liquid-dark-heavy rounded-3xl p-8 md:p-12 max-w-md mx-4 text-center border-2 border-white/20 shadow-liquid-2xl">
          <h1 className="text-6xl md:text-8xl font-bold text-primary mb-4 font-montserrat">
            404
          </h1>
          <h2 className="text-xl md:text-2xl font-semibold text-white mb-4">
            ERROR
          </h2>
          <p className="text-white/80 text-base md:text-lg mb-6">
            La página que visitas no existe
          </p>
          <div className="text-white/60 text-sm">
            Serás redirigido a la página principal en{" "}
            <span className="text-primary font-bold text-2xl animate-pulse inline-block min-w-[2ch]">{countdown}</span>{" "}
            segundos
          </div>
          <button
            onClick={() => navigate("/")}
            className="mt-6 px-6 py-3 glass-liquid-medium hover-liquid rounded-xl text-white font-semibold transition-all duration-300 hover:scale-105"
          >
            Ir al inicio ahora
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
